export default "__VITE_ASSET__DZJQ00UN__"